var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":"Home,Class,Order"}},[_c('router-view')],1),_c('div',{domProps:{"innerHTML":_vm._s(_vm.downHtml)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }